export enum rbacActions {

    GetDashboard = 'GetDashboard',
    ViewGettingStarted = 'ViewGettingStarted',

    ListDomainNames = 'ListDomainNames',
    GetDomainName = 'GetDomainName',
    CreateDomainName = 'CreateDomainName',
    UpdateDomainName = 'UpdateDomainName',
    DeleteDomainName = 'DeleteDomainName',
    BulkImportDomainNames = 'BulkImportDomainNames',

    ListRegistrars = 'ListRegistrars',
    GetRegistrar = 'GetRegistrar',
    CreateRegistrar = 'CreateRegistrar',
    UpdateRegistrar = 'UpdateRegistrar',
    DeleteRegistrar = 'DeleteRegistrar',

    // FNP-973 — read-only module: list and get only. No Create/Update/Delete
    // action, because the deployed schema has no hosted-zone mutation to gate
    // (writes are FNP-977).
    ListHostedZones = 'ListHostedZones',
    GetHostedZone = 'GetHostedZone',

    ListTopLevelDomains = 'ListTopLevelDomains',
    GetTopLevelDomain = 'GetTopLevelDomain',
    CreateTopLevelDomain = 'CreateTopLevelDomain',
    UpdateTopLevelDomain = 'UpdateTopLevelDomain',
    DeleteTopLevelDomain = 'DeleteTopLevelDomain',

    ListApplicationProducts = 'ListApplicationProducts',
    GetApplicationProduct = 'GetApplicationProduct',
    CreateApplicationProduct = 'CreateApplicationProduct',
    UpdateApplicationProduct = 'UpdateApplicationProduct',
    DeleteApplicationProduct = 'DeleteApplicationProduct',

    ListSettings = 'ListSettings',
    GetSetting = 'GetSetting',
    UpdateSetting = 'UpdateSetting',
}

export const actions = Object.values(rbacActions);

